import axios from "axios";

export const state = {
    reportexpenses: [],
};

export const getters = {
    reportexpenses: state => state.reportexpenses,
};

export const mutations = {
    setReportExpense(reportexpenses, newValue) { state.reportexpenses = newValue},
};

export const actions = {
    async fetchReportExpense({ commit }) {
        await axios.get('/reportexpenses').then(res => {
            commit('setReportExpense', res.data.expensesales)
        })
    },
    async filterReportExpense({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportexpenses";
        await axios.post(url, formData).then((response) => {
            commit('setReportExpense', response.data.expensesales)
        })
    },
};
